import { observer } from 'mobx-react';
import { Alert } from '@mui/material';
import { useAlertStore } from '../stores';

const GlobalAlert = observer(() => {
  const alertStore = useAlertStore();

  if (!alertStore.activeAlert) {
    return null;
  }

  return <Alert severity={alertStore.activeAlert.severity}>{alertStore.activeAlert.message}</Alert>;
});

export default GlobalAlert;
